import axios from "axios";
import {API_URL_PREFIX, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/auth';


class AuthService {
    login(email, password) {
        return axios
            .post(API_URL + "/signin", {
                email,
                password
            })
            .then(response => {
                if (response.data.jwt_token) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    forgotPass(email) {
        return axios
            .post(API_URL + "/forgotpass", {
                email
            })
            .then(response => {
                return response.data;
            });
    }

    validatePassToken(email, token) {
        return axios
            .post(API_URL + "/validatepasstoken", {
                email,
                token
            })
            .then(response => {
                return response.data;
            });
    }

    logout() {
        localStorage.removeItem("user");
    }

    register(name, email, password, roles) {
        return axios.post(API_URL + "/signup", {
            name,
            email,
            password,
            roles
        })
        .then(response => {
            if (response.data.jwt_token) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        });
    }

    updatePass(email, password) {
        return axios.post(API_URL + "/updatepass", {
            email,
            password
        })
        .then(response => {
            return response.data;
        });
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    // no header needed
    getUserResources(email) {
        let url = API_URL + '/user/' + email + '/resources';
        return axios.get(url).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

}

export default new AuthService();
